import { AxiosResponse } from "axios";
import { FormikValues } from "formik";
import { convertFormikToApplication } from "utilities/formik-values-converter";
import http from "utilities/http-common";

const baseUrl = "/api/Documents";

export async function createDocumentToSign(applicationId: string): Promise<ConnectiveResponse> {
  return await http
  .post(`${baseUrl}/create-document-to-sign/${applicationId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  })
  .then((resp: AxiosResponse<ConnectiveResponse>) => {
    localStorage.setItem("ConnectiveResponseUrl", resp.data.signUrl);
    return resp.data;
  });
}

export async function getDocumentToSign(applicationId: string, completionHash?: string) {
    const params = new URLSearchParams();
    if (completionHash) params.append('completionHash', completionHash);
    return await http
        .get(`${baseUrl}/get-document-to-sign/${applicationId}`, { params: params, responseType: 'blob' as 'json' })
        .then((resp: AxiosResponse<Blob>) => {
            return resp.data;
        });
}

export async function getVertrouwelijkDocumentToSign(applicationId: string, completionHash?: string) {
    const params = new URLSearchParams();
    console.info('COMPLETIONHASH FROM URL', completionHash)
    if (completionHash) params.append('completionHash', completionHash);
    return await http
        .get(`${baseUrl}/get-vertrouwelijk-document-to-sign/${applicationId}`, { params: params, responseType: 'blob' as 'json' })
        .then((resp: AxiosResponse<Blob>) => {
            return resp.data;
        });
}

export async function updateDocumentToSign(applicationId: string, completionHash: string): Promise<ConnectiveResponse> {
  return await http
  .post(`${baseUrl}/create-document-to-sign/${applicationId}?completionHash=${completionHash}`, {
    headers: {
      "Content-Type": "application/json",
    },
  })
  .then((resp: AxiosResponse<ConnectiveResponse>) => {
    localStorage.setItem("ConnectiveResponseUrl", resp.data.signUrl);
    return resp.data;
  });
}

export async function getPrivacyDocument(tenantId?: string): Promise<Blob> {
  const params = new URLSearchParams();
  if (tenantId) {
    params.append("tenantId", tenantId);
  }
  
  return http
    .get(`${baseUrl}/get-privacy-document`,{params, responseType: "blob"})
    .then((response: AxiosResponse<Blob>) => {
        return response.data;
    })
}
